import React from 'react'
import { useRiskCategories } from 'src/pages/AccountSettings/AccountSettings.hooks'
import { FilterName, FilterParam } from '../../FilterBar.types'
import { FilterDropdown } from '../FilterDropdown'

export const DashboardRiskCategoryFilterDropdown = ({
  isNested = false,
}: {
  isNested?: boolean
}): JSX.Element => {
  const { data: riskCategories } = useRiskCategories()
  const filterValues =
    riskCategories?.getOptionsList().map((riskCategory) => ({
      label: riskCategory.getName(),
      value: riskCategory.getName(),
    })) || []

  return (
    <FilterDropdown
      filterParam={FilterParam.DASHBOARD_RISK_CATEGORY}
      filterName={FilterName.DASHBOARD_RISK_CATEGORY}
      filterValues={filterValues}
      isNested={isNested}
    />
  )
}
